import { Component, ReactNode } from "react"

import { authFetch } from '../../libs/cookie/Cookie'

import Button from "../../libs/ui/buttons/Button"

import { RECALL_URL } from '../../costants'

export interface ModalProps {
    isOpen: boolean
    quoteRequestId: string | undefined
    callBackToggle: Function
    expiredSessionCallbak: Function
}
export interface ModalState {
    shwoTnks: boolean
    isSended: boolean
}

class ModalFinalQuestion extends Component<ModalProps, ModalState> {

    constructor (props: any) {
        super(props)

        this.state = {
            shwoTnks: false,
            isSended: false
        }

        this.exit = this.exit.bind(this)
        this.close = this.close.bind(this)
        this.rquestEmailAndClose = this.rquestEmailAndClose.bind(this)
        this.rquestPhoneAndClose = this.rquestPhoneAndClose.bind(this)
    }

    render(): ReactNode {

        return (
            (this.props.isOpen && this.props.quoteRequestId !== undefined) &&
            <>
                <div className="modal fade show" tabIndex={-1}>
                    <div className='modal-dialog modal-dialog-centered modal-lg'>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="modal-title titleLev4 colorPrimaryBlue mb-2">
                                    {
                                        this.state.isSended
                                            ?   'Grazie!'
                                            :   'Come vorresti ricevere il tuo preventivo?'
                                    }
                                </span>
                                <button 
                                    id='colse-modal'
                                    type='button' 
                                    className='btn-close' 
                                    onClick={
                                        this.state.isSended 
                                            ? this.close
                                            : this.exit
                                    }
                                ></button>
                            </div>
                            <div className="modal-body">

                                {this.state.isSended === true &&
                                    <div>
                                        <p>
                                            Abbiamo ricevuto i tuoi dati
                                            {this.state.shwoTnks &&
                                                <>
                                                    , ti contatteremo il prima possibile.
                                                </>
                                            }
                                            
                                        </p>
                                        <Button 
                                            id='user_confirm'
                                            type='button' 
                                            onClick={this.close}
                                        >
                                            Chiudi
                                        </Button>
                                    </div>
                                }

                                {this.state.isSended === false &&
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="blockChannel">
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className="titleLev6 colorPrimaryBlue">Via email</span>
                                                </div>
                                                <p>
                                                    Un nostro consulente ti invierà subito il miglior preventivo sul mercato.
                                                </p>
                                                <Button
                                                    id="request_email"
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={this.rquestEmailAndClose}
                                                >
                                                    Inoltra richiesta
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="blockChannel">
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className="titleLev6 colorPrimaryBlue">Per telefono</span>
                                                </div>
                                                <p>
                                                    Se ti va di fare una chiacchierata insieme, ti richiameremo a strettissimo giro.
                                                </p>
                                                <Button
                                                    type="button"
                                                    id="request_phone"
                                                    className="btn btn-secondary"
                                                    onClick={this.rquestPhoneAndClose}
                                                >
                                                    Inoltra richiesta
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div> 
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        )

    }

    private exit () {
        this.setState({
            isSended: false
        }, () => {
            this.setState({
                shwoTnks: false,
                isSended: true
            })
        })
    }

    private close () {
        this.props.callBackToggle ( false )
    }

    private rquestEmailAndClose () {
        authFetch (
            RECALL_URL,
            {
                method: 'post',
                body: JSON.stringify({
                    Quote_Request_Id: this.props.quoteRequestId,
                    Recall_Channel: 'email'
                })
            },
            this.props.expiredSessionCallbak
        )
        .then (jsonObj => {
            if (jsonObj.success || jsonObj?.errors[0]?.includes("not UPDATED")) {
                this.setState({
                    shwoTnks: true,
                    isSended: true
                })
            }
        })
    }

    private rquestPhoneAndClose () {
        authFetch (
            RECALL_URL,
            {
                method: 'post',
                body: JSON.stringify({
                    Quote_Request_Id: this.props.quoteRequestId,
                    Recall_Channel: 'phone'
                })
            },
            this.props.expiredSessionCallbak
        )
        .then (jsonObj => {
            if (jsonObj.success || jsonObj?.errors[0]?.includes("not UPDATED")) {
                this.setState({
                    shwoTnks: true,
                    isSended: true
                })
            }
        })
    }
}

export default ModalFinalQuestion